@for (row of rows; track row) {
  <div class="row">
    @for (panel of row; track panel; let last = $last; let first = $first) {
      @switch (panel.type) {
        @case ('list') {
          <lm-twelve-column-panel-list #card
            [ngClass]="{'last-child': last, 'first-child': first}"
            [panel]="panel"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            [isFlyoutContent]="isFlyoutContent"
            (componentDisplayed)="onComponentDisplayed()"
            (contentModified)="onContentModified($event)"
            (sendContextMessageEvent)="onSendContextMessageEvent($event)"
            (panelTransactionEvent)="onPanelTransactionEvent($event)"
            (drillAroundEvent)="onDrillAroundEvent($event)"
          ></lm-twelve-column-panel-list>
        }
        @case ('formlist') {
          <lm-twelve-column-panel-list #card
            [ngClass]="{'last-child': last, 'first-child': first}"
            [panel]="panel"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            [isFlyoutContent]="isFlyoutContent"
            (componentDisplayed)="onComponentDisplayed()"
            (contentModified)="onContentModified($event)"
            (sendContextMessageEvent)="onSendContextMessageEvent($event)"
            (panelTransactionEvent)="onPanelTransactionEvent($event)"
            (drillAroundEvent)="onDrillAroundEvent($event)"
          ></lm-twelve-column-panel-list>
        }
        @case ('standardform') {
          <lm-twelve-column-panel-form #card
            [ngClass]="{'last-child': last, 'first-child': first}"
            [panel]="panel"
            [formUrlInfo]="formUrlInfo"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            [isFlyoutContent]="isFlyoutContent"
            (componentDisplayed)="onComponentDisplayed()"
            (fieldEvent)="onFieldEvent($event)"
          ></lm-twelve-column-panel-form>
        }
        @case ('form') {
          <lm-twelve-column-panel-form #card
            [ngClass]="{'last-child': last, 'first-child': first}"
            [panel]="panel"
            [formUrlInfo]="formUrlInfo"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            [model]="model"
            [placeHolder]="placeHolder"
            [specFields]="specFields"
            [isFlyoutContent]="isFlyoutContent"
            (componentDisplayed)="onComponentDisplayed()"
            (fieldEvent)="onFieldEvent($event)"
          ></lm-twelve-column-panel-form>
        }
        @case ('independentform') {
          <lm-twelve-column-panel-form #card
            [ngClass]="{'last-child': last, 'first-child': first}"
            [panel]="panel"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            [isFlyoutContent]="isFlyoutContent"
            (componentDisplayed)="onComponentDisplayed()"
          ></lm-twelve-column-panel-form>
        }
        @case ('templateform') {
          <lm-twelve-column-panel-form-template #card
            [ngClass]="{'last-child': last, 'first-child': first}"
            [panel]="panel"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            [model]="model"
            [placeHolder]="placeHolder"
            [specFields]="specFields"
            (componentDisplayed)="onComponentDisplayed()"
          ></lm-twelve-column-panel-form-template>
        }
        @case ('instancecountchart') {
          <lm-twelve-column-panel-form #card
            [ngClass]="{'last-child': last, 'first-child': first}"
            [panel]="panel"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            [isFlyoutContent]="isFlyoutContent"
            (componentDisplayed)="onComponentDisplayed()"
            (fieldEvent)="onFieldEvent($event)"
          ></lm-twelve-column-panel-form>
        }
        @case ('cardview') {
          <lm-twelve-column-panel-card #card
            [ngClass]="{'last-child': last, 'first-child': first}"
            [panel]="panel"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            (uiLinkEvent)="onUILinkEvent($event)"
          ></lm-twelve-column-panel-card>
        }
        @case ('menuPanel') {
          <lm-twelve-column-panel-form #card
            [ngClass]="{'last-child': last, 'first-child': first}"
            [panel]="panel"
            [fromDataView]="messageRuleView"
            [messageRuleView]="messageRuleView"
            [isFlyoutContent]="isFlyoutContent"
            (componentDisplayed)="onComponentDisplayed()"
            (fieldEvent)="onFieldEvent($event)"
          ></lm-twelve-column-panel-form>
        }
        @case ('MenuLinkBoxPanel') {
          <lm-twelve-column-panel-form #card
            [ngClass]="{'last-child': last, 'first-child': first}"
            [panel]="panel"
            [fromDataView]="messageRuleView"
            [messageRuleView]="messageRuleView"
            [isFlyoutContent]="isFlyoutContent"
            (componentDisplayed)="onComponentDisplayed()"
            (fieldEvent)="onFieldEvent($event)"
          ></lm-twelve-column-panel-form>
        }
        @case ('url') {
          <lm-twelve-column-panel-url #card
            [ngClass]="{'last-child': last, 'first-child': first}"
            [panel]="panel"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            (uiLinkEvent)="onUILinkEvent($event)"
            (panelTransactionEvent)="onPanelTransactionEvent($event)"
          ></lm-twelve-column-panel-url>
        }
        @case ('link') {
          <lm-twelve-column-panel-url #card
            [ngClass]="{'last-child': last, 'first-child': first}"
            [panel]="panel"
            [fromDataView]="fromDataView"
            [messageRuleView]="messageRuleView"
            (uiLinkEvent)="onUILinkEvent($event)"
            (panelTransactionEvent)="onPanelTransactionEvent($event)"
          ></lm-twelve-column-panel-url>
        }
      }
    }
  </div>
}
